import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import Search from 'apollo-react-icons/Search';
import React, { useState } from 'react';

import LookupPopover from './LookupPopover';
import { INPUT_ICON_DEFAULT_SIZE } from '../../constants/CommonStylesConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  searchIcon: INPUT_ICON_DEFAULT_SIZE,
});

const LookupField = ({
  onLookup,
  lookupValues = [],
  showPopoverLoader,
  enableLookup,
  showLabel,
  value,
  ...textFieldProps
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState(null);

  const classes = useStyles();
  const translateString = useTranslation();

  const handleLookupBtnClick = (e) => {
    onLookup();
    setPopoverOpen(true);
    setPopoverAnchor(e.currentTarget);
  };
  const onPopoverClose = () => {
    setPopoverOpen(false);
  };
  const handleValueSelect = (value) => {
    textFieldProps.onChange(value);
    onPopoverClose();
  };
  const handleTextFieldChange = (e) => {
    textFieldProps.onChange(e.target.value);
  };

  return (
    <div className={classes.root}>
      <TextField
        {...textFieldProps}
        value={value ?? ''}
        icon={
          enableLookup ? <Search ui-ta="lookup-search" className={classes.searchIcon} /> : <></>
        }
        iconProps={{
          onClick: (e) => handleLookupBtnClick(e),
        }}
        onChange={handleTextFieldChange}
        label={showLabel ? translateString('Value') : null}
      />
      <LookupPopover
        open={popoverOpen}
        anchorEl={popoverAnchor}
        onClose={onPopoverClose}
        values={lookupValues}
        onSelect={handleValueSelect}
        showLoader={showPopoverLoader}
      />
    </div>
  );
};

export default LookupField;
